<template>
  <div class="auth-wrapper auth-v1 px-2">

    <b-modal
      ref="modal"
      hide-footer
      size="lg"
    >
      <p>
        Caro(a) cliente,
      </p>

      <p>
        Estamos sempre buscando maneiras de aprimorar sua experiência conosco e tornar sua interação com nossos serviços mais conveniente e eficiente. Para tanto, informamos que será necessária a realização de uma atualização na Plataforma ViaInvest Soulpay, que simplificará seu acesso, qual seja:
      </p>

      <p>
        Unificação de Acesso às Plataformas:
      </p>

      <p>
        Para melhorar sua experiência e segurança, implementamos um sistema de login unificado. Agora, você poderá acessar todos os seus estabelecimentos com um único login, permitindo que confira seus relatórios transacionais e efetue suas operações de pagamento online de forma mais simples e rápida.
      </p>

      <p>
        Para Ativar Seu Acesso Unificado, siga os seguintes passos:
      </p>

      <p>
        Solicitamos que redefina sua senha única, seguindo um simples processo de primeiro acesso. Isso é necessário para ativar seu acesso unificado e garantir que apenas você tenha acesso às suas informações.
      </p>

      <p>
        Agradecemos por sua cooperação e entendimento.
      </p>

      <p>
        Caso tenha dúvidas ou precise de assistência durante o processo, nossa equipe de suporte está à disposição para ajudá-lo através do telefone (11) 5555-2144.
      </p>

      <p class="text-primary">
        #aViaÉoCaminho
      </p>

    </b-modal>
    <div
      v-if="renderPage"
      class="auth-inner py-2"
    >
      <!-- Reset Password v1 -->
      <b-card class="mb-0">

        <!-- logo -->
        <b-link class="brand-logo">
          <img
            src="../../../assets/images/logo/logo.svg"
            class="logo-size"
          >
        </b-link>
        <div v-if="whatRender == 'input'">
          <b-card-title class="mb-1">
            Redefinir senha
          </b-card-title>
          <b-card-text class="mb-2 text-dark">
            {{ newPasswordMessage }}
          </b-card-text>

          <!-- form -->
          <validation-observer ref="simpleRules">
            <b-form
              method="POST"
              class="auth-reset-password-form mt-2"
              @submit.prevent="validationForm"
            >

              <!-- password -->
              <b-form-group
                label="Nova Senha"
                label-for="reset-password-new"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Nova Senha"
                  vid="Password"
                  rules="required|password"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="reset-password-new"
                      v-model="password"
                      :type="password1FieldType"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge input-color"
                      name="reset-password-new"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="password1ToggleIcon"
                        @click="togglePassword1Visibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- confirm password -->
              <b-form-group
                label-for="reset-password-confirm"
                label="Confirmar Senha"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Confirmar Senha"
                  rules="required|confirmed:Password"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="reset-password-confirm"
                      v-model="cPassword"
                      :type="password2FieldType"
                      class="form-control-merge input-color"
                      :state="errors.length > 0 ? false:null"
                      name="reset-password-confirm"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="password2ToggleIcon"
                        @click="togglePassword2Visibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- submit button -->
              <b-button
                block
                type="submit"
                variant="info"
              >
                Redefinir
              </b-button>
            </b-form>
          </validation-observer>
        </div>

        <div v-if="whatRender!=='input'">
          <b-col md="12">
            <b-row class="d-flex justify-content-center">
              <b-col
                style="margin-top: -1rem"
                class="d-flex align-items-xl-center"
                md="3"
                cols="12"
              >
                <Icon :type="whatRender" />
              </b-col>
              <b-col
                md="6"
                cols="12"
              >
                <div class="ml-1 text mt-2">
                  <h5>{{ whatRender === 'success' ? 'Senha alterada com sucesso' : 'Link é inválido ou está expirado' }}</h5>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </div>
      </b-card>

      <!-- /Reset Password v1 -->
    </div>
  </div>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver,
} from 'vee-validate'
import {
  BCard,
  BCardTitle,
  BCardText,
  BForm,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BLink,
  BFormInput,
  BRow,
  BCol,
  BModal,
  BButton,
} from 'bootstrap-vue'
import {
  required,
} from '@validations'

import { callLoading, removeDarkMode } from '@/service/utilities/utilities'
import { resetPassword, verifyHash } from '@/service/user/user'

import Icon from '@/layouts/components/Icon.vue'

export default {
  components: {
    BCard,
    BButton,
    BCardTitle,
    BCardText,
    BForm,
    BFormGroup,
    BInputGroup,
    BRow,
    BCol,
    BLink,
    BFormInput,
    BModal,
    BInputGroupAppend,
    Icon,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      userEmail: '',
      cPassword: '',
      password: '',
      // validation
      required,

      // Toggle Password
      password1FieldType: 'password',
      password2FieldType: 'password',

      hash: window.location.pathname.split('/')[2],

      newPasswordMessage: 'Sua nova senha precisa ser difente da sua senha antiga',

      whatRender: null,
      renderPage: false,
    }
  },
  computed: {
    password1ToggleIcon() {
      return this.password1FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    password2ToggleIcon() {
      return this.password2FieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  async mounted() {
    removeDarkMode()
    await this.verifyHash()
  },
  methods: {
    togglePassword1Visibility() {
      this.password1FieldType = this.password1FieldType === 'password' ? 'text' : 'password'
    },
    togglePassword2Visibility() {
      this.password2FieldType = this.password2FieldType === 'password' ? 'text' : 'password'
    },

    async verifyHash() {
      const isNewPassword = this.$route.query.new_password
      if (isNewPassword) {
        this.$refs.modal.show()
      }
      try {
        const response = await verifyHash(this.hash)
        const { status } = response
        this.whatRender = status === 200 ? 'input' : 'error'
      } catch {
        this.whatRender = 'error'
      } finally {
        this.renderPage = true
      }
    },

    async resetPassword() {
      callLoading(true)
      try {
        const response = await resetPassword(this.hash, this.password)
        if (response.status === 200) {
          this.whatRender = 'success'
          callLoading(false)
          await new Promise(resolve => setTimeout(resolve, 1750))
          this.$router.push('/')
        }
      } catch (err) {
        this.render = 'error'
      } finally {
        callLoading(false)
      }
    },

    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.resetPassword()
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
  @import '@core/scss/vue/pages/page-auth.scss';

  .text-response {
    margin-top: 2.2rem;
    text-align: center;
  }

  .icon-response {
    display: flex !important;
  }

  @media(max-width: "767px") {
    .text-response {
      margin-top: 0 !important;
    }
  }
</style>
